(function () {
  var RB_ACCOUNT_SELECTOR = '[data-rb-account-link], .rb-header__account';

  var RB_ACCOUNT_URL = '/account';

  function prepareRbAccountLink(link) {
    var href = link.getAttribute('href') || '';
    var needsHref = !href || href.indexOf('#k-hub') !== -1 || href.indexOf('/account') === -1;
    var needsIgnore = link.getAttribute('data-k-hub-ignore') !== '';

    if (!needsHref && !needsIgnore && !link.hasAttribute('data-drawer-options') &&
        !link.hasAttribute('data-drawer-delay') && !link.hasAttribute('data-drawer-delay-')) {
      return;
    }

    if (needsIgnore) link.setAttribute('data-k-hub-ignore', '');
    link.removeAttribute('data-drawer-options');
    link.removeAttribute('data-drawer-delay');
    link.removeAttribute('data-drawer-delay-');
    if (needsHref) link.setAttribute('href', RB_ACCOUNT_URL);
  }

  function prepareRbAccountLinks() {
    document.querySelectorAll(RB_ACCOUNT_SELECTOR).forEach(prepareRbAccountLink);
  }

  prepareRbAccountLinks();
  document.addEventListener('DOMContentLoaded', prepareRbAccountLinks);

  function syncHeaderHeight() {
    /* Mobile: header/tophat are in document flow on every template */
    if (window.innerWidth <= 999) {
      document.documentElement.style.setProperty('--rb-header-height', '0px');
      document.body.classList.remove('rb-scrolled');
      return;
    }

    if (document.body.classList.contains('template-index')) return;

    var trust = document.querySelector('.rb-trust-strip');
    var header = document.querySelector('.rb-header');
    if (!trust && !header) return;

    var height = 0;
    var isScrolled = document.body.classList.contains('rb-scrolled');

    if (isScrolled) {
      height = 0;
    } else {
      var trustHeight = trust ? trust.offsetHeight : 0;
      height = trustHeight + (header ? header.offsetHeight : 0);
    }

    document.documentElement.style.setProperty('--rb-header-height', height + 'px');
  }

  syncHeaderHeight();
  window.addEventListener('resize', syncHeaderHeight);
  window.addEventListener('load', syncHeaderHeight);
  document.addEventListener('DOMContentLoaded', syncHeaderHeight);

  function initHeaderScrollHide() {
    var lastScrollY = window.scrollY;
    var isHidden = false;
    var scrollAccumulator = 0;
    var maxScrollWhileHidden = 0;
    var lastToggleAt = 0;
    var ticking = false;
    var trust = document.querySelector('.rb-trust-strip');
    var header = document.querySelector('.rb-header');
    var isHomepage = document.body.classList.contains('template-index');
    var showAtTop = 16;
    var hideAfterY = 72;
    var minDeltaHide = isHomepage ? 5 : 8;
    var minDeltaShow = isHomepage ? 5 : 48;
    var toggleCooldownMs = isHomepage ? 350 : 500;
    var scrollIntentThreshold = 2;

    function applyHiddenState(hidden, force) {
      if (hidden === isHidden) return;

      var now = Date.now();
      if (!force && now - lastToggleAt < toggleCooldownMs) return;

      isHidden = hidden;
      lastToggleAt = now;
      scrollAccumulator = 0;

      if (hidden) {
        maxScrollWhileHidden = window.scrollY;
        document.body.classList.add('rb-scrolled');
      } else {
        maxScrollWhileHidden = 0;
        document.body.classList.remove('rb-scrolled');
        syncHeaderHeight();
      }
    }

    function onHeaderTransitionEnd(event) {
      if (event.propertyName !== 'transform' || !isHidden) return;
      syncHeaderHeight();
    }

    if (trust) trust.addEventListener('transitionend', onHeaderTransitionEnd);
    if (header) header.addEventListener('transitionend', onHeaderTransitionEnd);

    function updateScrollState() {
      /* Mobile: header/tophat stay in document flow — never sticky-hide */
      if (window.innerWidth <= 999) {
        if (document.body.classList.contains('rb-scrolled')) {
          document.body.classList.remove('rb-scrolled');
          isHidden = false;
        }
        lastScrollY = window.scrollY;
        return;
      }

      var scrollY = window.scrollY;
      var delta = scrollY - lastScrollY;

      if (scrollY <= showAtTop) {
        // Always restore at top — bypass cooldown so nav can't stick hidden
        applyHiddenState(false, true);
        syncHeaderHeight();
      } else if (isHidden) {
        if (isHomepage) {
          if (delta < -scrollIntentThreshold) {
            scrollAccumulator += delta;
            if (scrollAccumulator <= -minDeltaShow) {
              applyHiddenState(false);
            }
          } else if (delta > scrollIntentThreshold) {
            scrollAccumulator = 0;
          }
        } else {
          maxScrollWhileHidden = Math.max(maxScrollWhileHidden, scrollY);
          if (maxScrollWhileHidden - scrollY >= minDeltaShow) {
            applyHiddenState(false);
          }
        }
      } else if (delta > scrollIntentThreshold && scrollY > hideAfterY) {
        scrollAccumulator += delta;
        if (scrollAccumulator >= minDeltaHide) {
          applyHiddenState(true);
        }
      } else if (delta < -scrollIntentThreshold) {
        scrollAccumulator = 0;
      }

      lastScrollY = scrollY;
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateScrollState);
    }

    applyHiddenState(false);
    if (window.innerWidth <= 999) {
      document.body.classList.remove('rb-scrolled');
      isHidden = false;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  initHeaderScrollHide();

  function updateRbCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
    document.body.classList.toggle('t4s-cart-count-0', count === 0);
  }

  document.addEventListener('cart:update:count', function (event) {
    var count = event.detail && event.detail.count;
    if (count != null) updateRbCartCount(parseInt(count, 10) || 0);
  });

  function setNavMenuBridges() {
    if (window.innerWidth < 1000) return;
    document.querySelectorAll('.rb-header__dropdown').forEach(function (dropdown) {
      var menu = dropdown.querySelector('.rb-header__menu');
      if (!menu) return;
      dropdown.style.setProperty('--rb-menu-width', menu.offsetWidth + 'px');
    });
  }
  setNavMenuBridges();
  window.addEventListener('resize', setNavMenuBridges);

  document.querySelectorAll('.rb-header__dropdown').forEach(function (dropdown) {
    var pill = dropdown.querySelector('.rb-header__pill');
    if (!pill) return;

    dropdown.addEventListener('mouseleave', function () {
      if (dropdown.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    });
  });

  var carousel = document.querySelector('[data-hero-carousel]');
  if (!carousel) return;

  var slides = carousel.querySelectorAll('[data-hero-slide]');
  var dots = carousel.querySelectorAll('[data-hero-dot]');
  if (slides.length <= 1) return;
  var track = carousel.querySelector('[data-hero-track]');
  var rail = carousel.querySelector('[data-rb-hero-rail]');
  var bar = carousel.querySelector('[data-rb-hero-bar]');
  var thumb = carousel.querySelector('[data-rb-hero-thumb]');
  var current = 0;
  var timer;
  var baseDelay = parseInt(carousel.getAttribute('data-autoplay-ms') || '8000', 10);
  var currentDelay = baseDelay;
  var MOBILE_MAX = 999;
  var THUMB_MIN = 48;
  var scrollRaf = 0;
  var programmaticScroll = false;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function updateDotTheme() {
    var controls = carousel.querySelector('.rb-hero__controls');
    if (!controls || !slides[current]) return;
    var theme = slides[current].classList.contains('rb-hero__slide--canna') ? 'light' : 'dark';
    controls.setAttribute('data-dot-theme', theme);
  }

  function syncActiveClasses(index) {
    slides.forEach(function (slide, i) {
      var on = i === index;
      slide.classList.toggle('is-active', on);
      slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (dots[i]) {
        dots[i].classList.toggle('is-active', on);
        dots[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
    });
    current = index;
    updateDotTheme();
  }

  var heroThumbState = { x: 0, target: 0, raf: 0, width: 0 };

  function syncHeroThumb(options) {
    if (!rail || !bar || !thumb || !track) return;
    if (!isMobile()) {
      rail.setAttribute('hidden', '');
      return;
    }
    rail.removeAttribute('hidden');
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var barWidth = bar.clientWidth || track.clientWidth;
    var thumbWidth = Math.max(
      THUMB_MIN,
      Math.round(barWidth * (track.clientWidth / Math.max(track.scrollWidth, 1)))
    );
    var maxOffset = Math.max(0, barWidth - thumbWidth);
    var progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
    var targetX = progress * maxOffset;
    var snap = !!(options && options.snap);

    if (heroThumbState.width !== thumbWidth) {
      heroThumbState.width = thumbWidth;
      thumb.style.width = thumbWidth + 'px';
    }

    heroThumbState.target = targetX;
    if (snap) {
      if (heroThumbState.raf) {
        window.cancelAnimationFrame(heroThumbState.raf);
        heroThumbState.raf = 0;
      }
      heroThumbState.x = targetX;
      thumb.style.transform = 'translate3d(' + targetX + 'px, 0, 0)';
      return;
    }

    if (heroThumbState.raf) return;
    heroThumbState.raf = window.requestAnimationFrame(function tick() {
      var delta = heroThumbState.target - heroThumbState.x;
      if (Math.abs(delta) < 0.2) {
        heroThumbState.x = heroThumbState.target;
        heroThumbState.raf = 0;
      } else {
        heroThumbState.x += delta * 0.45;
        heroThumbState.raf = window.requestAnimationFrame(tick);
      }
      thumb.style.transform = 'translate3d(' + heroThumbState.x + 'px, 0, 0)';
    });
  }

  function indexFromScroll() {
    if (!track || !track.clientWidth) return current;
    return Math.round(track.scrollLeft / track.clientWidth);
  }

  function goTo(index, fromScroll) {
    if (!slides.length) return;
    var nextIndex = (index + slides.length) % slides.length;
    syncActiveClasses(nextIndex);

    if (isMobile() && track && !fromScroll) {
      programmaticScroll = true;
      track.scrollTo({
        left: nextIndex * track.clientWidth,
        behavior: 'smooth'
      });
      window.setTimeout(function () {
        programmaticScroll = false;
        syncHeroThumb({ snap: true });
      }, 420);
    }
    syncHeroThumb({ snap: true });
  }

  function next() { goTo(current + 1); }

  function startAutoplay() {
    stopAutoplay();
    timer = window.setInterval(next, currentDelay);
  }

  function stopAutoplay() {
    if (timer) window.clearInterval(timer);
  }

  function restartAutoplay() {
    stopAutoplay();
    startAutoplay();
  }

  dots.forEach(function (dot, index) {
    dot.addEventListener('click', function () {
      goTo(index);
      restartAutoplay();
    });
  });

  if (track) {
    track.addEventListener('scroll', function () {
      if (!isMobile()) return;
      if (scrollRaf) return;
      scrollRaf = window.requestAnimationFrame(function () {
        scrollRaf = 0;
        syncHeroThumb();
        if (programmaticScroll) return;
        var idx = indexFromScroll();
        if (idx !== current && idx >= 0 && idx < slides.length) {
          syncActiveClasses(idx);
        }
      });
    }, { passive: true });

    track.addEventListener('scrollend', function () {
      if (!isMobile()) return;
      programmaticScroll = false;
      var idx = indexFromScroll();
      if (idx !== current && idx >= 0 && idx < slides.length) {
        syncActiveClasses(idx);
      }
      syncHeroThumb({ snap: true });
      restartAutoplay();
    }, { passive: true });

    track.addEventListener('touchstart', function () {
      if (isMobile()) stopAutoplay();
    }, { passive: true });
  }

  function setHoverSpeed(isHovered) {
    // Desktop-only: slow rotation by 50% while hovered.
    if (window.innerWidth < 1000) return;
    currentDelay = isHovered ? Math.round(baseDelay * 1.5) : baseDelay;
    restartAutoplay();
  }

  carousel.addEventListener('mouseenter', function () {
    setHoverSpeed(true);
  });

  carousel.addEventListener('mouseleave', function () {
    setHoverSpeed(false);
  });

  window.addEventListener('resize', function () {
    if (isMobile() && track) {
      track.scrollLeft = current * track.clientWidth;
    }
    syncHeroThumb({ snap: true });
  });

  syncHeroThumb({ snap: true });
  startAutoplay();
})();
